export const AZI_API_ENDPOINT = 'gaspar/azi';

export const CAT_NAT_API_ENDPOINT = 'gaspar/catnat';

export const CAVITES_API_ENDPOINT = 'cavites';

export const DICRIM_API_ENDPOINT = 'gaspar/dicrim';

export const ETATS_DOCUMENTS_PPR_API_ENDPOINT = 'ppr/etats_documents';

export const FAMILLES_RISQUE_PPR_API_ENDPOINT = 'ppr/famille_risques';

export const INSTALLATIONS_CLASSEES_API_ENDPOINT = 'installations_classees';

export const MVT_API_ENDPOINT = 'mvt';

export const OLD_API_ENDPOINT = 'old';

export const PAPI_API_ENDPOINT = 'gaspar/papi';

export const PPR_API_ENDPOINT = 'ppr';

export const RADON_API_ENDPOINT = 'radon';

export const RAPPORT_PDF_API_ENDPOINT = 'rapport_pdf';

export const RETRAIT_GONFLEMENT_ARGILES_API_ENDPOINT = 'rga';

export const RISQUES_API_ENDPOINT = 'gaspar/risques';

export const SIS_API_ENDPOINT = 'sis';

export const TIM_API_ENDPOINT = 'gaspar/tim';

export const TRI_API_ENDPOINT = 'gaspar/tri';

export const TRI_ZONAGE_REGLEMENTAIRE_API_ENDPOINT = 'tri_zonage';

export const ZONAGE_SISMIQUE_API_ENDPOINT = 'zonage_sismique';
